import React from 'react';

export const AlertDeleteIcon = () => (
	<svg width='57' height='46' viewBox='0 0 57 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='34' cy='23' r='23' fill='#A1ABB9' fillOpacity='0.1' />
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M4.34204 10.6094H35.6858V37.8333C35.6858 40.4107 33.5964 42.5 31.0191 42.5H9.00871C6.43138 42.5 4.34204 40.4107 4.34204 37.8333V10.6094ZM8.34204 14.6094V37.8333C8.34204 38.2015 8.64052 38.5 9.00871 38.5H31.0191C31.3873 38.5 31.6858 38.2015 31.6858 37.8333V14.6094H8.34204Z'
			fill='#292929'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M9.26392 14.6094H30.7639V9.5C30.7639 6.18629 28.0776 3.5 24.7639 3.5H15.2639C11.9502 3.5 9.26392 6.18629 9.26392 9.5V14.6094ZM13.2639 10.6094V9.5C13.2639 8.39543 14.1593 7.5 15.2639 7.5H24.7639C25.8685 7.5 26.7639 8.39543 26.7639 9.5V10.6094H13.2639Z'
			fill='#292929'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M1 12.4119C1 11.3073 1.89543 10.4119 3 10.4119L37.0278 10.4119C38.1323 10.4119 39.0278 11.3073 39.0278 12.4119C39.0278 13.5164 38.1323 14.4119 37.0278 14.4119L3 14.4119C1.89543 14.4119 1 13.5164 1 12.4119Z'
			fill='#292929'
		/>
	</svg>
);
export const AlertUnsavedIcon = () => (
	<svg width='57' height='46' viewBox='0 0 57 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='34' cy='23' r='23' fill='#A1ABB9' fillOpacity='0.1' />
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M22 4.8501C22.765 4.8501 23.4751 5.24746 23.8752 5.89946L43.1252 37.2697C43.5418 37.9486 43.5589 38.7996 43.1699 39.4947C42.7809 40.1898 42.0466 40.6203 41.25 40.6203H2.75005C1.95353 40.6203 1.21922 40.1898 0.830231 39.4947C0.441245 38.7996 0.458347 37.9486 0.874942 37.2697L20.1249 5.89946C20.525 5.24746 21.2351 4.8501 22 4.8501ZM6.68124 36.2203H37.3189L22 11.2565L6.68124 36.2203Z'
			fill='#292929'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M22 18.05C23.215 18.05 24.2 19.035 24.2 20.25L24.2 25.7501C24.2 26.9651 23.215 27.9501 22 27.9501C20.7849 27.9501 19.7999 26.9651 19.8 25.7501L19.8 20.25C19.8 19.035 20.7849 18.05 22 18.05Z'
			fill='#292929'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M22 29.05C23.2151 29.05 24.2001 30.035 24.2001 31.25L24.2001 31.8C24.2001 33.0151 23.2151 34 22 34C20.785 34 19.8 33.0151 19.8 31.8L19.8 31.25C19.8 30.035 20.785 29.05 22 29.05Z'
			fill='#292929'
		/>
	</svg>
);

export const OneToOneIcon = () => (
	<svg width='57' height='46' viewBox='0 0 57 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='34' cy='23' r='23' fill='#A1ABB9' fillOpacity='0.1' />
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M5.38887 20.7236C5.38887 16.8613 8.46284 13.6499 12.3528 13.6499C16.2428 13.6499 19.3168 16.8613 19.3168 20.7236C19.3168 24.5859 16.2428 27.7973 12.3528 27.7973C8.46284 27.7973 5.38887 24.5859 5.38887 20.7236ZM12.3528 17.8499C10.8703 17.8499 9.58887 19.0921 9.58887 20.7236C9.58887 22.3551 10.8703 23.5973 12.3528 23.5973C13.8354 23.5973 15.1168 22.3551 15.1168 20.7236C15.1168 19.0921 13.8354 17.8499 12.3528 17.8499ZM22.2867 20.7236C22.2867 16.808 25.4726 13.6499 29.3827 13.6499C33.2929 13.6499 36.4788 16.808 36.4788 20.7236C36.4788 24.6392 33.2929 27.7973 29.3827 27.7973C25.4726 27.7973 22.2867 24.6392 22.2867 20.7236ZM29.3827 17.8499C27.7744 17.8499 26.4867 19.1454 26.4867 20.7236C26.4867 22.3018 27.7744 23.5973 29.3827 23.5973C30.9911 23.5973 32.2788 22.3018 32.2788 20.7236C32.2788 19.1454 30.9911 17.8499 29.3827 17.8499ZM4.79032 37.2749H19.9151C19.7792 36.3988 19.438 35.5976 18.9463 34.9209C17.9878 33.6018 16.4736 32.771 14.7848 32.771H9.92086C7.36967 32.771 5.18995 34.6907 4.79032 37.2749ZM2.6249 41.4749C1.4651 41.4749 0.524902 40.5347 0.524902 39.3749V38.1311C0.524902 32.8953 4.68783 28.571 9.92086 28.571H14.7848C17.0934 28.571 19.2001 29.4182 20.8283 30.8109C22.4149 29.3767 24.4468 28.571 26.8847 28.571H31.8808C37.1704 28.571 41.4749 32.842 41.4749 38.1311V39.3749C41.4749 40.5347 40.5347 41.4749 39.3749 41.4749H2.6249ZM24.1435 37.2749H37.2063C36.7943 34.7276 34.574 32.771 31.8808 32.771H26.8847C25.3776 32.771 24.2458 33.2614 23.3557 34.209C23.7765 35.1599 24.0489 36.1926 24.1435 37.2749Z'
			fill='#292929'
		/>
		<path
			d='M11.5498 7.35C11.5498 6.1902 12.49 5.25 13.6498 5.25V5.25C14.8096 5.25 15.7498 6.1902 15.7498 7.35V7.35C15.7498 8.5098 14.8096 9.45 13.6498 9.45V9.45C12.49 9.45 11.5498 8.5098 11.5498 7.35V7.35Z'
			fill='#292929'
		/>
		<path
			d='M18.8999 7.35C18.8999 6.1902 19.8401 5.25 20.9999 5.25V5.25C22.1597 5.25 23.0999 6.1902 23.0999 7.35V7.35C23.0999 8.5098 22.1597 9.45 20.9999 9.45V9.45C19.8401 9.45 18.8999 8.5098 18.8999 7.35V7.35Z'
			fill='#292929'
		/>
		<path
			d='M26.25 7.35C26.25 6.1902 27.1902 5.25 28.35 5.25V5.25C29.5098 5.25 30.45 6.1902 30.45 7.35V7.35C30.45 8.5098 29.5098 9.45 28.35 9.45V9.45C27.1902 9.45 26.25 8.5098 26.25 7.35V7.35Z'
			fill='#292929'
		/>
	</svg>
);
export const AlertSavedIcon = () => (
	<svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M7.34955 61.0209L5 71.5939L26.5 63M49.6414 46.9236C53.7531 50.4479 51.4035 53.3849 49.1699 54.0552L45.8363 55.3914M11.5 41.5C10.9444 46.1014 18.4994 58.4995 26.5 63M26.5 63L35.0022 59.7344L45.8363 55.3914M22.6216 21.0786C20.677 20.2434 16.6675 20.815 16.6675 24.8239C16.6675 29.8349 26.6683 48.376 45.8363 55.3914'
			stroke='#292929'
			strokeWidth='6'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M32 6.5C34.0294 10.1548 35.5 14.5 30.5 25.5'
			stroke='#292929'
			strokeWidth='6'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M44.4559 24.272L34.5 35M40 43.5L50.5 34L60.5 25.5'
			stroke='#292929'
			strokeWidth='6'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<rect x='44' y='11' width='2.34955' height='2.34955' rx='1.17477' stroke='#292929' strokeWidth='6' />
		<path
			d='M59.7622 13L58.5874 10.6504'
			stroke='#292929'
			strokeWidth='6'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M70.7023 19.9443L73.6472 18.4052'
			stroke='#292929'
			strokeWidth='6'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M68.1423 32.5369L70.3578 36.9631'
			stroke='#292929'
			strokeWidth='6'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const Logo = () => (
	<svg width='21' height='25' viewBox='0 0 21 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M9.17944 24.999C7.83453 24.999 6.66381 24.8172 5.66728 24.4536C4.67076 24.0899 3.84032 23.5919 3.17596 22.9595C2.51161 22.3271 2.0174 21.5801 1.69333 20.7184C1.36925 19.8567 1.20721 18.9279 1.20721 17.9318V8.91998H6.99194V17.3152C6.99194 18.1216 7.19043 18.75 7.58742 19.2006C7.98441 19.6512 8.54749 19.8765 9.27666 19.8765C10.0058 19.8765 10.5689 19.6512 10.9659 19.2006C11.3629 18.75 11.5614 18.1216 11.5614 17.3152V12.2401L17.3218 9.82117V17.9279C17.3218 18.9239 17.1476 19.8528 16.7992 20.7144C16.4508 21.5761 15.9364 22.3231 15.2558 22.9556C14.5753 23.588 13.7286 24.086 12.7159 24.4496C11.7032 24.8172 10.5243 24.999 9.17944 24.999Z'
			fill='#282929'
		/>
		<path
			d='M3.17595 22.9911C3.8403 23.6274 4.67074 24.1255 5.66322 24.4931L7.58741 19.2282C7.19852 18.7697 7.00407 18.1334 7.00407 17.3231V11.7776L1.1991 9.8725V17.9397C1.1991 18.9397 1.36113 19.8764 1.68521 20.75C2.01333 21.6077 2.50755 22.3547 3.17595 22.9911Z'
			fill='url(#paint0_linear)'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M7.00002 15.7144C6.28706 15.7816 5.54979 15.5484 5.00292 15.0187L1.1991 11.3033V9.8725L7.00002 11.7737V15.7144Z'
			fill='#292929'
			fillOpacity='0.5'
		/>
		<path
			d='M13.7083 1.47332C15.7216 -0.491107 18.9867 -0.491107 21 1.47332L10.3825 11.833L6.73669 8.27569L13.7083 1.47332Z'
			fill='url(#paint1_linear)'
		/>
		<path
			d='M0.725152 9.46936C-0.243019 8.5247 -0.243019 6.9911 0.725152 6.04644L0.862883 5.91205C1.83105 4.96739 3.40281 4.96739 4.37099 5.91205L10.4109 11.8053C8.39761 13.7698 5.13661 13.7698 3.1233 11.8053L0.725152 9.46936Z'
			fill='url(#paint2_linear)'
		/>
		<path
			d='M3.17595 22.9911C3.8403 23.6274 4.67074 24.1255 5.66322 24.4931L7.58741 19.2282C7.19852 18.7697 7.00407 18.1334 7.00407 17.3231V11.7776L1.1991 9.8725V17.9397C1.1991 18.9397 1.36113 19.8764 1.68521 20.75C2.01333 21.6077 2.50755 22.3547 3.17595 22.9911Z'
			fill='url(#paint3_linear)'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M7.00002 15.7144C6.28706 15.7816 5.54979 15.5484 5.00292 15.0187L1.1991 11.3033V9.8725L7.00002 11.7737V15.7144Z'
			fill='#292929'
			fillOpacity='0.5'
		/>
		<path
			d='M13.7083 1.47332C15.7216 -0.491107 18.9867 -0.491107 21 1.47332L10.3825 11.833L6.73669 8.27569L13.7083 1.47332Z'
			fill='url(#paint4_linear)'
		/>
		<path
			d='M0.725152 9.46936C-0.243019 8.5247 -0.243019 6.9911 0.725152 6.04644L0.862883 5.91205C1.83105 4.96739 3.40281 4.96739 4.37099 5.91205L10.4109 11.8053C8.39761 13.7698 5.13661 13.7698 3.1233 11.8053L0.725152 9.46936Z'
			fill='url(#paint5_linear)'
		/>
		<defs>
			<linearGradient
				id='paint0_linear'
				x1='4.39382'
				y1='9.87353'
				x2='4.39382'
				y2='24.4896'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#CB00FF' />
				<stop offset='0.637' stopColor='#CD0CFF' stopOpacity='0' />
			</linearGradient>
			<linearGradient
				id='paint1_linear'
				x1='19.177'
				y1='-0.306206'
				x2='8.81966'
				y2='10.3088'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='0.7292' stopColor='#6A02FF' />
				<stop offset='1' stopColor='#5101A8' />
			</linearGradient>
			<linearGradient
				id='paint2_linear'
				x1='0.794463'
				y1='5.9792'
				x2='8.39481'
				y2='13.7687'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='0.4948' stopColor='#CD0CFF' />
				<stop offset='1' stopColor='#6A02FF' />
			</linearGradient>
			<linearGradient
				id='paint3_linear'
				x1='4.39382'
				y1='9.87353'
				x2='4.39382'
				y2='24.4896'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#CB00FF' />
				<stop offset='0.637' stopColor='#CD0CFF' stopOpacity='0' />
			</linearGradient>
			<linearGradient
				id='paint4_linear'
				x1='19.177'
				y1='-0.306206'
				x2='8.81966'
				y2='10.3088'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='0.7292' stopColor='#6A02FF' />
				<stop offset='1' stopColor='#5101A8' />
			</linearGradient>
			<linearGradient
				id='paint5_linear'
				x1='0.794463'
				y1='5.9792'
				x2='8.39481'
				y2='13.7687'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='0.4948' stopColor='#CD0CFF' />
				<stop offset='1' stopColor='#6A02FF' />
			</linearGradient>
		</defs>
	</svg>
);

export const CloseIcon = () => (
	<svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z'
			fill='#E3E6EA'
		/>
		<path
			d='M18.0163 17.2287C16.94 16.1525 15.8638 15.0762 14.7875 14C15.5663 13.2212 16.345 12.4425 17.115 11.6725C17.4125 11.375 17.7188 11.0687 18.0163 10.7712C18.515 10.2725 17.7363 9.485 17.2375 9.9925C16.1613 11.0687 15.085 12.145 14.0088 13.2212C13.23 12.4425 12.4513 11.6637 11.6813 10.8937C11.3838 10.5962 11.0775 10.29 10.78 9.9925C10.2813 9.49375 9.49375 10.2725 10.0013 10.7712C11.0775 11.8475 12.1538 12.9237 13.23 14C12.4513 14.7787 11.6725 15.5575 10.9025 16.3275C10.605 16.625 10.2988 16.9312 10.0013 17.2287C9.5025 17.7275 10.2813 18.515 10.78 18.0075C11.8563 16.9312 12.9325 15.855 14.0088 14.7787C14.7875 15.5575 15.5663 16.3362 16.3363 17.1062C16.6338 17.4037 16.94 17.71 17.2375 18.0075C17.7363 18.515 18.515 17.7362 18.0163 17.2287Z'
			fill='#292929'
		/>
	</svg>
);

export const LeftArrowIcon = () => (
	<svg width='16' height='16' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M20.4783 6.88465C20.1557 6.70138 19.7596 6.70545 19.441 6.8953L9.57376 14.1141C9.26157 14.3 9.07031 14.6366 9.07031 15C9.07031 15.3634 9.26157 15.7 9.57376 15.8859L19.441 23.1047C19.7596 23.2946 20.1557 23.2986 20.4783 23.1153C20.8008 22.9321 21 22.5897 21 22.2188L21 7.78125C21 7.4103 20.8008 7.06793 20.4783 6.88465Z'
			fill='#292929'
		/>
	</svg>
);

export const RightArrowIcon = () => (
	<svg width='16' height='16' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M9.52175 6.88465C9.84426 6.70138 10.2404 6.70545 10.559 6.8953L20.4262 14.1141C20.7384 14.3 20.9297 14.6366 20.9297 15C20.9297 15.3634 20.7384 15.7 20.4262 15.8859L10.559 23.1047C10.2404 23.2946 9.84426 23.2986 9.52175 23.1153C9.19923 22.9321 9 22.5897 9 22.2188L9 7.78125C9 7.4103 9.19923 7.06793 9.52175 6.88465Z'
			fill='#292929'
		/>
	</svg>
);

export const BackArrow = () => (
	<svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M6.94537 3.65772C6.63295 3.3453 6.12642 3.3453 5.814 3.65772L1.814 7.65772C1.50158 7.97013 1.50158 8.47667 1.814 8.78909L5.814 12.7891C6.12642 13.1015 6.63295 13.1015 6.94537 12.7891C7.25779 12.4767 7.25779 11.9701 6.94537 11.6577L4.31106 9.0234H15.3797C15.8215 9.0234 16.1797 8.66523 16.1797 8.2234C16.1797 7.78157 15.8215 7.4234 15.3797 7.4234H4.31106L6.94537 4.78909C7.25779 4.47667 7.25779 3.97013 6.94537 3.65772Z'
			fill='#292929'
		/>
	</svg>
);

export const DeskPhone = () => (
	<svg width='20' height='20' viewBox='0 0 31 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12.25 0.922363L12.25 4.31247H30.8928V28.9962H0.892822V1.03614L12.25 0.922363ZM3.89282 4.00623V25.9962H27.8928V7.31247H9.24997L9.24996 3.95257L3.89282 4.00623Z'
			fill='#292929'
		/>
		<path fillRule='evenodd' clipRule='evenodd' d='M9.25 28.3125V7.125H12.25V28.3125H9.25Z' fill='#292929' />
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M28.75 14.25L10.375 14.25L10.375 11.25L28.75 11.25L28.75 14.25Z'
			fill='#292929'
		/>
		<path fillRule='evenodd' clipRule='evenodd' d='M17.5 19.5H14.5V16.5H17.5V19.5Z' fill='#292929' />
		<path fillRule='evenodd' clipRule='evenodd' d='M17.5 24H14.5V21H17.5V24Z' fill='#292929' />
		<path fillRule='evenodd' clipRule='evenodd' d='M21.625 19.5H18.625V16.5H21.625V19.5Z' fill='#292929' />
		<path fillRule='evenodd' clipRule='evenodd' d='M21.625 24H18.625V21H21.625V24Z' fill='#292929' />
		<path fillRule='evenodd' clipRule='evenodd' d='M25.75 19.5H22.75V16.5H25.75V19.5Z' fill='#292929' />
		<path fillRule='evenodd' clipRule='evenodd' d='M25.75 24H22.75V21H25.75V24Z' fill='#292929' />
	</svg>
);

export const TwitterIcon = () => (
	<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<g clipPath='url(#clip0)'>
			<path
				d='M17.96 6.4575C17.96 6.27667 17.9533 6.10083 17.945 5.9275C18.7583 5.35 19.4425 4.62917 20 3.79917V3.79833C19.2558 4.12417 18.4642 4.34083 17.6375 4.44583C18.4875 3.93833 19.1367 3.14083 19.4417 2.18C18.6492 2.6525 17.7742 2.98583 16.8417 3.1725C16.0892 2.37083 15.0167 1.875 13.8467 1.875C11.5767 1.875 9.74917 3.7175 9.74917 5.97583C9.74917 6.30083 9.77667 6.61333 9.84417 6.91083C6.43583 6.74417 3.41917 5.11083 1.3925 2.62167C1.03917 3.23583 0.830833 3.93833 0.830833 4.69417C0.830833 6.11417 1.56167 7.3725 2.6525 8.10167C1.99333 8.08917 1.3475 7.8975 0.8 7.59667V7.64167C0.8 9.63417 2.22083 11.2892 4.085 11.6708C3.45833 11.8425 2.68667 11.8358 2.23417 11.7358C2.765 13.3592 4.27333 14.5533 6.065 14.5925C4.67 15.6833 2.89833 16.3408 0.980833 16.3408C0.645 16.3408 0.3225 16.3258 0 16.285C1.81667 17.4558 3.96833 18.125 6.29 18.125C13.835 18.125 17.96 11.875 17.96 6.4575Z'
				fill='#55ACEE'
			/>
		</g>
		<defs>
			<clipPath id='clip0'>
				<rect width='20' height='20' fill='white' />
			</clipPath>
		</defs>
	</svg>
);

export const SkypeIcon = () => (
	<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M19.4242 12.1214C20.8725 5.61308 15.1708 -0.299415 8.475 0.835585C4.84 -1.42025 0 1.12892 0 5.45392C0 6.45975 0.2775 7.40142 0.76 8.21309C-0.585833 14.7364 5.1625 20.5639 11.8525 19.3514C12.6325 19.7639 13.5225 19.9989 14.4683 19.9989C18.5925 19.9989 21.2333 15.7214 19.4242 12.1214ZM10.08 16.5648C8.12833 16.5648 6.22167 16.0939 5.09333 14.4823C3.41167 12.1039 5.62917 10.9139 6.7175 11.8206C7.62583 12.5864 7.34083 14.4389 10.0083 14.4389C11.1842 14.4389 12.6358 13.9373 12.6358 12.7714C12.6358 10.4256 7.43167 11.5356 5.3625 8.97808C4.6025 8.04142 4.45917 6.38892 5.3925 5.19058C7.01917 3.09725 11.7925 2.96975 13.845 4.55058C15.74 6.01725 15.2283 7.96392 13.6992 7.96392C11.86 7.96392 12.8267 5.55725 9.8575 5.55725C7.705 5.55725 6.85833 7.08808 8.37417 7.83309C10.3917 8.83475 15.6658 8.52225 15.6658 12.5023C15.6592 15.2998 12.96 16.5648 10.08 16.5648Z'
			fill='#03A9F4'
		/>
	</svg>
);

export const LinkedInIcon = () => (
	<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M19.9951 20V19.9992H20.0001V12.6642C20.0001 9.07587 19.2276 6.31171 15.0326 6.31171C13.0159 6.31171 11.6626 7.41837 11.1101 8.46754H11.0517V6.64671H7.07422V19.9992H11.2159V13.3875C11.2159 11.6467 11.5459 9.96337 13.7017 9.96337C15.8259 9.96337 15.8576 11.95 15.8576 13.4992V20H19.9951Z'
			fill='#0077B5'
		/>
		<path d='M0.3302 6.64771H4.47687V20.0002H0.3302V6.64771Z' fill='#0077B5' />
		<path
			d='M2.40167 0C1.07583 0 0 1.07583 0 2.40167C0 3.7275 1.07583 4.82583 2.40167 4.82583C3.7275 4.82583 4.80333 3.7275 4.80333 2.40167C4.8025 1.07583 3.72667 0 2.40167 0V0Z'
			fill='#0077B5'
		/>
	</svg>
);
export const WhatsNewPopupIcon = () => (
	<svg width='73' height='83' viewBox='0 0 73 83' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M36.1324 64.4027C36.5477 63.9166 36.836 63.3349 36.9716 62.7098C37.1071 62.0848 37.0857 61.4358 36.9092 60.821C36.7326 60.2063 36.4065 59.645 35.9601 59.1874C35.5136 58.7298 34.9607 58.3903 34.351 58.1992C35.0324 57.321 35.5796 56.3026 35.7091 55.1978C35.8387 54.093 35.4962 52.8955 34.6496 52.1759C33.4657 51.1697 31.6515 51.337 30.2493 52.006L26.6409 42.7826C26.516 42.3695 26.264 41.8655 25.8351 41.9097C25.287 41.9662 25.2837 42.7649 25.4439 43.2928L29.1047 52.678C26.7843 54.2309 24.6625 56.0622 22.7866 58.1311L18.9987 45.5059C18.8732 45.1081 18.3071 44.3472 17.8792 44.862C17.7028 45.0743 17.7042 45.458 17.7238 45.7161C17.7297 45.7944 19.8219 53.1776 19.877 53.1352C16.7511 55.5398 14.5233 58.9586 12.9722 62.5865C11.4211 66.2144 10.4997 70.0748 9.58546 73.9135C9.49671 74.2862 9.44842 74.7662 9.77361 74.9685C10.0189 75.121 10.3588 75.0037 10.5475 74.7849C10.7362 74.5661 10.8109 74.274 10.8797 73.9932C11.7541 70.4165 12.6008 66.8136 14.0089 63.4123C15.417 60.0109 17.4283 56.7856 20.2833 54.464L21.8651 59.4778C21.8994 59.6248 21.9675 59.7617 22.064 59.8777C22.4441 60.2666 23.069 59.8152 23.4194 59.399C25.321 57.1406 27.5604 55.1906 30.058 53.6183C31.1883 52.9073 32.7303 52.2966 33.7672 53.1385C34.4251 53.6726 34.5961 54.6439 34.3847 55.4651C34.1733 56.2863 33.6472 56.9869 33.0997 57.634C32.7387 58.0603 32.3593 58.7101 32.746 59.1135C32.9663 59.343 33.3239 59.3428 33.6387 59.3875C34.1218 59.4561 34.5743 59.6646 34.9406 59.9875C35.3068 60.3103 35.5707 60.7333 35.6998 61.2044C35.829 61.6755 35.8176 62.1741 35.6673 62.6388C35.5169 63.1036 35.234 63.5141 34.8535 63.8199C34.505 64.1 34.0248 64.4074 34.11 64.8466C34.2091 65.3582 34.9114 65.3804 35.4121 65.5227C36.2594 65.7636 36.7874 66.6783 36.8078 67.56C36.8281 68.4416 36.4369 69.2829 35.9561 70.0216C34.2546 72.6341 31.4068 74.3395 29.7294 76.9675C28.9386 78.2091 28.4373 79.6131 28.2628 81.0753C28.238 81.2845 28.2249 81.5148 28.3465 81.687C28.5679 82.0003 29.096 81.8916 29.3305 81.5887C29.565 81.2857 29.6005 80.8791 29.6627 80.5005C29.9449 78.7895 30.9462 77.2773 32.1121 75.9945C33.2779 74.7116 34.6251 73.6053 35.8025 72.3333C36.8586 71.1919 37.8031 69.852 38.0246 68.3119C38.246 66.7718 37.5532 65.0157 36.1167 64.4212L36.1324 64.4027Z'
			fill='white'
			stroke='white'
			stroke-width='1.5'
		/>
		<path
			d='M9.33404 46.5838C9.97625 46.4066 11.1717 46.0767 12.5072 45.5947C12.6666 45.5372 12.7966 45.4186 12.8686 45.2651C12.9407 45.1116 12.9489 44.9357 12.8914 44.7762C12.834 44.6166 12.7155 44.4865 12.5622 44.4143C12.4089 44.3422 12.2332 44.334 12.0738 44.3915C10.7846 44.8569 9.62014 45.1783 8.99437 45.351C8.09059 45.6007 7.21526 45.5311 6.59307 45.1599C6.20926 44.919 5.88865 44.5895 5.65803 44.1991L5.95452 44.0949C6.58711 43.8732 7.1846 43.663 7.54318 43.5251C7.62297 43.4961 7.69618 43.4515 7.75855 43.3938C7.82091 43.3362 7.87117 43.2667 7.9064 43.1893C7.94162 43.112 7.9611 43.0285 7.96369 42.9435C7.96629 42.8586 7.95194 42.774 7.9215 42.6946C7.89107 42.6153 7.84514 42.5429 7.78641 42.4815C7.72768 42.4201 7.65733 42.3711 7.57946 42.3373C7.50159 42.3035 7.41776 42.2855 7.33289 42.2845C7.24801 42.2835 7.16378 42.2994 7.08512 42.3313C6.74442 42.4625 6.12768 42.6789 5.53164 42.8881C5.38403 42.94 5.23668 42.9917 5.09188 43.0428C5.00424 42.8247 4.35803 41.0547 4.33537 40.9921C4.64362 40.8826 4.95365 40.7734 5.2578 40.6663C5.70982 40.5072 6.13168 40.3587 6.47408 40.2348C6.55298 40.2063 6.62548 40.1625 6.68745 40.1059C6.74943 40.0492 6.79966 39.981 6.83528 39.9049C6.8709 39.8289 6.8912 39.7466 6.89505 39.6627C6.89889 39.5788 6.88618 39.495 6.85766 39.416C6.82914 39.337 6.78536 39.2644 6.72881 39.2024C6.67227 39.1403 6.60408 39.09 6.52812 39.0544C6.45217 39.0187 6.36994 38.9984 6.28613 38.9945C6.20233 38.9907 6.11859 39.0034 6.0397 39.032C5.70011 39.1547 5.28165 39.302 4.83355 39.4598C4.52514 39.5684 4.21051 39.6792 3.89724 39.7905C3.87373 39.7272 3.40221 38.4603 3.18076 37.7441L5.24358 37.0027C5.32306 36.9748 5.39624 36.9314 5.45889 36.875C5.52154 36.8186 5.57244 36.7504 5.60865 36.6743C5.64486 36.5981 5.66567 36.5155 5.66988 36.4313C5.67409 36.3471 5.66161 36.2629 5.63317 36.1835C5.60473 36.1041 5.56089 36.0311 5.50416 35.9688C5.44744 35.9064 5.37896 35.8559 5.30266 35.8202C5.22636 35.7844 5.14375 35.7641 5.05959 35.7605C4.97542 35.7568 4.89137 35.7698 4.81226 35.7988L2.85327 36.5027C2.72968 35.9002 2.68871 35.3693 2.81715 35.0568C3.15521 34.2308 3.97262 33.7745 4.4294 33.5762C5.44516 33.1425 6.48371 32.7643 7.54045 32.4434C7.70238 32.3934 7.83786 32.2812 7.91709 32.1312C7.99633 31.9813 8.01282 31.806 7.96296 31.6439C7.91309 31.4818 7.80095 31.3462 7.65119 31.2669C7.50143 31.1876 7.32633 31.171 7.16441 31.221C6.06305 31.5554 4.98068 31.9495 3.92211 32.4017C2.82525 32.8777 2.0132 33.6481 1.6358 34.57C1.12995 35.8016 1.84779 37.9467 2.62637 40.0374C2.67747 40.1749 2.7244 40.3007 2.76503 40.4126C2.99389 41.0407 3.0972 41.325 3.20043 41.6103C3.30332 41.8939 3.40664 42.179 3.63422 42.8041C3.80133 43.2617 3.97432 43.71 4.17363 44.1325C4.1778 44.141 4.18129 44.1495 4.18581 44.158C4.59507 45.0187 5.11761 45.769 5.93902 46.2591C6.54728 46.6112 7.23953 46.7915 7.94205 46.7809C8.41277 46.778 8.88097 46.7117 9.33404 46.5838Z'
			fill='white'
			stroke='white'
			stroke-width='2'
		/>
		<path
			d='M52.8487 23.6971C50.3257 16.6284 47.7168 9.31928 45.5301 2.23706C45.4888 2.10351 45.405 1.98716 45.2915 1.90581C45.1779 1.82447 45.0409 1.78261 44.9013 1.78664C44.7618 1.79068 44.6273 1.84038 44.5187 1.92814C44.41 2.01591 44.333 2.13691 44.2996 2.27262C41.7855 12.4657 29.8331 19.5406 22.9322 22.8514C22.8559 22.8872 22.7873 22.9378 22.7306 23.0003C22.6738 23.0628 22.63 23.1359 22.6016 23.2154C22.5733 23.295 22.5609 23.3793 22.5653 23.4637C22.5697 23.548 22.5907 23.6306 22.6272 23.7068C22.6636 23.7829 22.7148 23.8511 22.7777 23.9074C22.8406 23.9636 22.914 24.0069 22.9937 24.0346C23.0734 24.0623 23.1577 24.0739 23.2419 24.0688C23.3261 24.0637 23.4085 24.0419 23.4843 24.0048C28.7676 21.4704 33.4438 18.4744 37.0075 15.3406C40.8841 11.9316 43.5393 8.31976 44.9241 4.57827C46.9836 11.0666 49.35 17.6965 51.6455 24.1279C53.9842 30.6799 56.3969 37.4394 58.4784 44.0324C55.0226 42.2166 50.5552 40.981 45.6959 40.5145C40.1813 39.9849 34.4818 40.4727 29.6472 41.8873C29.4845 41.9349 29.3474 42.0453 29.266 42.194C29.1846 42.3428 29.1656 42.5179 29.2132 42.6807C29.2607 42.8435 29.3709 42.9808 29.5195 43.0623C29.6681 43.1438 29.843 43.1628 30.0057 43.1152C34.6882 41.7449 40.217 41.2734 45.574 41.7877C50.9426 42.3032 55.7941 43.7779 59.2348 45.9403C59.3452 46.0097 59.4742 46.0436 59.6045 46.0375C59.7348 46.0313 59.86 45.9854 59.9635 45.9058C60.0669 45.8263 60.1435 45.717 60.1831 45.5926C60.2226 45.4682 60.2232 45.3346 60.1847 45.2099C57.9898 38.1007 55.3762 30.7784 52.8487 23.6971Z'
			fill='white'
			stroke='white'
			stroke-width='2'
		/>
		<path
			d='M66.0948 8.13351C66.0307 8.07937 65.9565 8.03841 65.8765 8.01296C65.7966 7.98752 65.7124 7.97809 65.6288 7.98522C65.5452 7.99234 65.4639 8.01588 65.3894 8.05449C65.3148 8.09311 65.2487 8.14603 65.1946 8.21025L60.5744 13.6961C60.467 13.8259 60.4151 13.993 60.4302 14.161C60.4452 14.3289 60.5259 14.4841 60.6546 14.5928C60.7834 14.7015 60.9498 14.7549 61.1177 14.7413C61.2856 14.7278 61.4413 14.6484 61.551 14.5205L66.1714 9.03471C66.2255 8.9705 66.2664 8.89626 66.2918 8.81622C66.3172 8.73618 66.3266 8.65192 66.3195 8.56823C66.3124 8.48454 66.2889 8.40308 66.2504 8.32849C66.2118 8.2539 66.1589 8.18764 66.0948 8.13351Z'
			fill='white'
			stroke='white'
			stroke-width='2'
		/>
		<path
			d='M70.384 16.6142C70.3544 16.5356 70.3097 16.4637 70.2523 16.4024C70.1949 16.3411 70.1261 16.2917 70.0496 16.2571C69.9732 16.2225 69.8907 16.2032 69.8069 16.2005C69.723 16.1978 69.6395 16.2117 69.561 16.2413L64.1174 18.295C64.0389 18.3246 63.967 18.3694 63.9058 18.4268C63.8446 18.4842 63.7953 18.5532 63.7607 18.6297C63.7261 18.7062 63.7069 18.7888 63.7042 18.8727C63.7015 18.9567 63.7153 19.0403 63.7449 19.1189C63.7745 19.1975 63.8192 19.2695 63.8766 19.3308C63.934 19.392 64.0028 19.4414 64.0792 19.476C64.1557 19.5107 64.2382 19.5299 64.322 19.5326C64.4059 19.5353 64.4894 19.5215 64.5679 19.4919L70.0115 17.4382C70.1701 17.3784 70.2984 17.258 70.3682 17.1034C70.4381 16.9489 70.4437 16.7729 70.384 16.6142Z'
			fill='white'
			stroke='white'
			stroke-width='2'
		/>
		<path
			d='M70.9105 25.9143L65.7331 23.2408C65.6585 23.2023 65.5771 23.1789 65.4935 23.1719C65.4099 23.1649 65.3257 23.1745 65.2458 23.2C65.1659 23.2256 65.0918 23.2667 65.0277 23.3209C64.9637 23.3751 64.9109 23.4415 64.8724 23.5161C64.834 23.5908 64.8106 23.6723 64.8036 23.756C64.7966 23.8397 64.8062 23.9239 64.8317 24.0039C64.8572 24.0839 64.8983 24.1581 64.9524 24.2222C65.0066 24.2864 65.0729 24.3392 65.1474 24.3777L70.3249 27.0512C70.3994 27.0897 70.4808 27.1131 70.5644 27.1201C70.648 27.1271 70.7322 27.1176 70.8121 27.092C70.892 27.0665 70.9661 27.0254 71.0302 26.9712C71.0943 26.9169 71.147 26.8506 71.1855 26.776C71.2239 26.7013 71.2473 26.6198 71.2543 26.5361C71.2613 26.4524 71.2518 26.3682 71.2262 26.2882C71.2007 26.2082 71.1597 26.134 71.1055 26.0699C71.0514 26.0057 70.9851 25.9529 70.9105 25.9144V25.9143Z'
			fill='white'
			stroke='white'
			stroke-width='2'
		/>
		<path
			d='M47.767 16.885L52.6862 30.6989C55.3048 28.8862 57.9489 27.3162 60.5277 25.1421C59.3549 22.1874 58.4309 19.2634 57.2581 16.3088C54.0195 16.2545 50.9578 16.7814 47.767 16.885Z'
			fill='#E9B44D'
		/>
		<path
			d='M12.1228 25.1244C10.4449 25.5768 8.56617 26.1906 7.82781 27.7655C7.14829 29.2152 7.70909 30.9152 8.27436 32.4134C9.77407 36.39 11.1613 39.9947 12.661 43.9713C13.1383 45.2369 13.6997 46.6038 14.8812 47.2609C16.3022 48.0516 18.0919 47.6196 19.6258 47.0799C24.1442 45.4899 29.0841 44.939 33.6025 43.3491L25.5267 20.501C20.9678 21.7301 16.6813 23.8954 12.1228 25.1244Z'
			fill='#E9B44D'
		/>
	</svg>
);

export const GreyLogo = () => (
	<svg width='43' height='49' viewBox='0 0 43 49' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<g opacity='0.2'>
			<path
				opacity='0.6'
				d='M18.8947 48.8457C16.2344 48.8457 13.9186 48.4916 11.9474 47.7833C9.97618 47.0751 8.3335 46.1051 7.01935 44.8734C5.70521 43.6417 4.72761 42.1867 4.08657 40.5085C3.44552 38.8303 3.125 37.0212 3.125 35.0813V17.5293H14.5677V33.8803C14.5677 35.4508 14.9603 36.6748 15.7456 37.5524C16.5309 38.43 17.6447 38.8688 19.087 38.8688C20.5294 38.8688 21.6432 38.43 22.4285 37.5524C23.2138 36.6748 23.6064 35.4508 23.6064 33.8803V23.9958L35.001 19.2845V35.0736C35.001 37.0135 34.6564 38.8226 33.9673 40.5008C33.2782 42.179 32.2605 43.634 30.9143 44.8657C29.5681 46.0974 27.8934 47.0674 25.8901 47.7756C23.8869 48.4916 21.5551 48.8457 18.8947 48.8457Z'
				fill='#292929'
			/>
			<path
				d='M7.01975 44.9322C8.3339 46.1717 9.97658 47.1416 11.9398 47.8576L15.746 37.6035C14.9767 36.7105 14.5921 35.4711 14.5921 33.893V23.0924L3.10938 19.3818V35.0939C3.10938 37.0416 3.4299 38.866 4.07094 40.5674C4.72 42.2379 5.6976 43.6928 7.01975 44.9322Z'
				fill='url(#paint0_linear_13324_214031)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.5841 30.7598C13.1738 30.8907 11.7154 30.4365 10.6337 29.4049L3.10938 22.1686V19.3818L14.5841 23.0847V30.7598Z'
				fill='#292929'
				fill-opacity='0.5'
			/>
			<path
				d='M27.8491 3.02381C31.8316 -0.802208 38.2901 -0.802208 42.2726 3.02381L21.2704 23.2009L14.0586 16.2725L27.8491 3.02381Z'
				fill='url(#paint1_linear_13324_214031)'
			/>
			<path
				d='M2.16681 18.5954C0.251688 16.7555 0.251688 13.7686 2.16681 11.9288L2.43926 11.667C4.35438 9.82714 7.46345 9.82714 9.37858 11.667L21.3261 23.1451C17.3436 26.9711 10.893 26.9711 6.91055 23.1451L2.16681 18.5954Z'
				fill='url(#paint2_linear_13324_214031)'
			/>
			<path
				d='M7.01975 44.9322C8.3339 46.1717 9.97658 47.1416 11.9398 47.8576L15.746 37.6035C14.9767 36.7105 14.5921 35.4711 14.5921 33.893V23.0924L3.10938 19.3818V35.0939C3.10938 37.0416 3.4299 38.866 4.07094 40.5674C4.72 42.2379 5.6976 43.6928 7.01975 44.9322Z'
				fill='url(#paint3_linear_13324_214031)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.5841 30.7598C13.1738 30.8907 11.7154 30.4365 10.6337 29.4049L3.10938 22.1686V19.3818L14.5841 23.0847V30.7598Z'
				fill='#292929'
				fill-opacity='0.5'
			/>
			<path
				d='M27.8491 3.02381C31.8316 -0.802208 38.2901 -0.802208 42.2726 3.02381L21.2704 23.2009L14.0586 16.2725L27.8491 3.02381Z'
				fill='url(#paint4_linear_13324_214031)'
			/>
			<path
				d='M2.16681 18.5954C0.251688 16.7555 0.251688 13.7686 2.16681 11.9288L2.43926 11.667C4.35438 9.82714 7.46345 9.82714 9.37858 11.667L21.3261 23.1451C17.3436 26.9711 10.893 26.9711 6.91055 23.1451L2.16681 18.5954Z'
				fill='url(#paint5_linear_13324_214031)'
			/>
		</g>
		<defs>
			<linearGradient
				id='paint0_linear_13324_214031'
				x1='9.4288'
				y1='19.3838'
				x2='9.4288'
				y2='47.8508'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#3E3E3E' />
				<stop offset='0.637' stopColor='#919191' stopOpacity='0' />
			</linearGradient>
			<linearGradient
				id='paint1_linear_13324_214031'
				x1='38.6665'
				y1='-0.442085'
				x2='18.5042'
				y2='20.5448'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='0.7292' stopColor='#797979' />
				<stop offset='1' stopColor='#111111' />
			</linearGradient>
			<linearGradient
				id='paint2_linear_13324_214031'
				x1='2.30392'
				y1='11.7978'
				x2='17.0993'
				y2='27.1984'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='0.4948' stopColor='#929292' />
				<stop offset='1' stopColor='#515151' />
			</linearGradient>
			<linearGradient
				id='paint3_linear_13324_214031'
				x1='9.4288'
				y1='19.3838'
				x2='9.4288'
				y2='47.8508'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#3E3E3E' />
				<stop offset='0.637' stopColor='#919191' stopOpacity='0' />
			</linearGradient>
			<linearGradient
				id='paint4_linear_13324_214031'
				x1='38.6665'
				y1='-0.442085'
				x2='18.5042'
				y2='20.5448'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='0.7292' stopColor='#A7A7A7' />
				<stop offset='1' stopColor='#4F4F4F' />
			</linearGradient>
			<linearGradient
				id='paint5_linear_13324_214031'
				x1='2.30392'
				y1='11.7978'
				x2='17.0993'
				y2='27.1984'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='0.4948' stopColor='#929292' />
				<stop offset='1' stopColor='#515151' />
			</linearGradient>
		</defs>
	</svg>
);
export const BigBackArrowIcon = () => (
	<svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M2.73922 15.5909C1.90024 16.4298 1.90024 17.7901 2.73922 18.6291L13.4809 29.3708C14.3199 30.2097 15.6801 30.2097 16.5191 29.3708L27.2608 18.6291C28.0998 17.7901 28.0998 16.4298 27.2608 15.5909C26.4218 14.7519 25.0616 14.7519 24.2226 15.5909L17.1484 22.6651V2.14834C17.1484 0.961843 16.1865 0 15 0C13.8135 0 12.8517 0.961843 12.8517 2.14834L12.8517 22.6651L5.77743 15.5909C4.93845 14.7519 3.5782 14.7519 2.73922 15.5909Z'
			fill='#292929'
		/>
	</svg>
);

export const LeftArrow = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M16.875 10H3.125" stroke="#5C5C5C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M8.75 4.375L3.125 10L8.75 15.625" stroke="#5C5C5C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)